module.exports = __webpack_public_path__ + "img/dummy_customer_avatar.16746285.jpg";